import React from 'react';
import { Card } from 'antd';
import { useTheme } from '@/components/common/ThemeProvider';
import CircuitBreakerDashboard from '../components/CircuitBreakerDashboard';

const CircuitBreakerView: React.FC = () => {
    const { dark } = useTheme();

    return (
        <div className="space-y-6">
            <Card className={dark ? 'bg-gray-800 text-white' : ''}>
                <CircuitBreakerDashboard />
            </Card>
        </div>
    );
};

export default CircuitBreakerView;
